import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button } from '../../Button';

interface Properties {
    routeTo: string;
    fullWidth?: boolean;
    disable?: boolean;
    lowProfile?: boolean;
    reverse?: boolean;
    withMarginTop?: boolean;
    withMarginBottom?: boolean;
    style?: React.CSSProperties;
}

function Back({ routeTo, ...props }: Properties): React.ReactElement {
    const { t } = useTranslation(['common']);
    const history = useHistory();
    return (
        <Button
            {...props}
            text={t('common:back')}
            type="button"
            inverse
            callback={() => {
                if (routeTo) {
                    history.push(routeTo);
                } else {
                    history.goBack();
                }
            }}
        />
    );
}

export default Back;
